'use client'
import { ProductPurchase } from '@/components/ProductPurchase/ProductPurchase'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { wrapper } from './QuickPurchaseBlock.css'

type QuickPurchaseBlockProps = SbBaseBlockProps<{
  products: Array<string>
  campaignCode?: string
  attributedTo?: string
  ribbonText?: string
}>

export const QuickPurchaseBlock = ({ blok, nested }: QuickPurchaseBlockProps) => {
  return (
    <ProductPurchase
      className={wrapper}
      products={blok.products}
      campaignCode={blok.campaignCode}
      attributedTo={blok.attributedTo}
      nested={nested}
      ribbonText={blok.ribbonText}
    />
  )
}
